import { IssueModule } from '../models/support.models';

/**
 * Route prefix → module, used to pre-fill the report form when it is opened from the
 * in-page button so the user does not have to tell us where they already are.
 *
 * Built from the ACTUAL route table in app.routes.ts (every authenticated route lives
 * under `/app`), not from an idealised product map. In particular: wallets and
 * exchanges are one unified `/app/integrations` page, and there is no `/reports` route
 * — export lives inside Tax Center. Keep this in step with app.routes.ts.
 *
 * Longest prefix wins, so a future `/app/transactions/import` still resolves to
 * Transactions rather than falling through to Other.
 */
const ROUTE_MODULE_MAP: ReadonlyArray<readonly [string, IssueModule]> = [
  ['/app/dashboard', 'dashboard'],
  ['/app/portfolio', 'portfolio'],
  ['/app/transactions', 'transactions'],
  ['/app/tax-center', 'tax_center'],
  ['/app/integrations', 'integrations'],
  ['/app/ai-optimizer', 'ai_optimizer'],
  ['/app/harvestable-losses', 'harvestable_losses'],
  ['/app/rwa-assets', 'rwa_assets'],
  ['/app/zk-proofs', 'zk_proofs'],
  ['/app/residency', 'residency'],
  ['/app/api-management', 'api_management'],
  ['/app/settings', 'settings'],
  ['/auth', 'authentication']
];

export function moduleFromRoute(url: string): IssueModule {
  const path = (url || '').split('?')[0];

  const match = ROUTE_MODULE_MAP
    .filter(([prefix]) => path.startsWith(prefix))
    .sort((a, b) => b[0].length - a[0].length)[0];

  return match ? match[1] : 'other';
}
